import 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import { selectFromTheme } from '@thisisbud/sc-utils';
import { jsx } from 'react/jsx-runtime';

let _ = t => t,
  _t;
const cardClassName = 'bui-card';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledCard = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledCard",
  componentId: "sc-1givyjm-0"
})(_t || (_t = _`
  position: relative;
  display: flex;
  background-color: ${0};
  border-radius: ${0};
  border:  ${0} solid ${0};
  padding: ${0};

  .bui-table + &,
  & + & {
    margin-top: ${0};
  }
`), selectFromTheme('colorBackgroundCard'), selectFromTheme('borderRadiusCardDefault'), "0.0625rem", selectFromTheme('colorDivider'), selectFromTheme('paddingCardDefault'), selectFromTheme('spacingLargeDefault'));

/**
 * Renders a basic card that can be used as a base for other card component types.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { Card } from '@thisisbud/bui-react-card'
 *
 * function Example() {
 *   return <Card>Foobar</Card>
 * }
 * ```
 */
function Card(props) {
  const {
    as,
    children,
    className
  } = props;
  return /*#__PURE__*/jsx(StyledCard, {
    as: as,
    className: classnames(cardClassName, className),
    children: children
  });
}
Card.displayName = 'Card';

export { Card, cardClassName };
